import { ROOT_GLOBAL } from "../../global/root";
import { Site } from "../../models/Site";
import shuffle from "lodash/fp/shuffle";

import classNames from "classnames";
import { DComponent } from "../DComponent";
import { Paging } from '../../models/Paging';
import { replaceVariable } from '../../utils/string';
import { defer } from '../../utils/script';
import { MINI_APP } from '../../utils/miniApp';
import { LocalStorage } from '../../models/LocalStorage';
import { getParamUrl } from '../../utils/url';
import { DEFAULT_PER_PAGE_STORES } from "../../utils/constant";
import { apiSearchSite } from "../../utils/api";
import { EVENTS, listenEvent } from "../../utils/event";
import { Search } from "../../models/Search";
import { SiteCategory } from "../../models/SiteCategory";

export default class AvailableStore extends DComponent {
  constructor({
    parent,
    id,
    title,
    hasBorder = false,
    description,
    seeAll,
    noSlider = false,
    isLoadMore = false,
    type,
    perPage,
    data = [],
    paging,
    slidesToShow = 5,
    slidesToScroll = 3,
    rows = 1,
    autoplay = true,
    centerModeMobile = true,
    centerPaddingMobile = "20%",
    arrowsMobile = false,
    slidesToShowMobile = 1.5,
    slidesToScrollMobile = 1,
    isFullState = true,
    isPaging = false,
    isCallApi = false,
    isBoostSales = true,
    section = "",
    isFullWidth = false,
    callBackApiData,
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("AvailableStore", {
        "has-border": hasBorder,
        "see-more-site": seeAll,
        "no-slider": noSlider,
        "load-more": isLoadMore,
        "is-loading": true,
        "full-state": isFullState,
        "is-full-width": isFullWidth,
        "is-paging": isPaging,
      }),
    }, true);
    this.title = title;
    this.hasBorder = hasBorder;
    this.description = description;
    this.seeAll = seeAll;
    this.noSlider = noSlider;
    this.isLoadMore = isLoadMore;
    this.type = type;
    this.perPage = perPage;
    this.data = data;
    this.paging = paging
    this.slidesToShow = slidesToShow;
    this.rows = rows;
    this.autoplay = autoplay;
    this.centerModeMobile = centerModeMobile;
    this.centerPaddingMobile = centerPaddingMobile;
    this.arrowsMobile = arrowsMobile;
    this.slidesToShowMobile = slidesToShowMobile;
    this.slidesToScrollMobile = slidesToScrollMobile;
    this.slidesToScroll = slidesToScroll;
    this.isFullState = isFullState;
    this.isPaging = isPaging;
    this.isCallApi = isCallApi;
    this.isBoostSales = isBoostSales;
    this.section = section;
    this.isFullWidth = isFullWidth;
    this.callBackApiData = callBackApiData;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "AvailableStore");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    this.setUpLoading();

    if (this.title) {
      $(".title h2", this.element).attr("data-i18n", `[html]${this.title}`);
      if (this.hasBorder) {
        $(".title", this.element).addClass("has-border");
      }
      $(".title", this.element).removeClass("hide");
    }

    if (this.description) {
      $(".description", this.element).attr("data-i18n", this.description);
      $(".description", this.element).removeClass("hide");
    }

    if (!this.noSlider) {
      $(".flex-box.slider-nav", this.element).slick({
        slidesToShow: this.slidesToShow,
        slidesToScroll: this.slidesToScroll,
        focusOnSelect: true,
        infinite: true,
        autoplay: this.autoplay,
        autoplaySpeed: 4000,
        accessibility: false,
        swipeToSlide: true,
        touchThreshold: 1000,
        speed: 300,
        responsive: [
          {
            breakpoint: 1440,
            settings: {
              slidesToShow: this.slidesToShow,
              slidesToScroll: this.slidesToScroll,
            }
          },
          {
            breakpoint: 1100,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: this.slidesToShowMobile,
              slidesToScroll: this.slidesToScrollMobile,
              arrows: this.arrowsMobile,
              centerMode: this.centerModeMobile,
              centerPadding: this.centerPaddingMobile,
            }
          }
        ],
        nextArrow: `<img class="slick-next slick-arrow" alt="icon" src="${require("../../assets/images/icons/Arrow_Right_Orange.svg")}" />`,
        prevArrow: `<img class="slick-prev slick-arrow" alt="icon" src="${require("../../assets/images/icons/Arrow_Left_Orange.svg")}" />`
      });
      $(".flex-box.slider-nav", this.element).slick("refresh");
    } else {
      $(`.flex-box`, this.element).addClass("no-slider")
    }

    $(window).scroll(function () {
      const top = $(this).scrollTop() + $(this).height() - ($(this).width() > 768 ? 200 : 0);
      $(this.element).each(function (i, obj) {
        if (top >= obj.offsetTop) {
          $(obj).find(".logo-site").addClass("active");
        }
      });
    });

    const type = getParamUrl("type");
    this.element.on("click", ".box-item a", (e) => {
      let id = $(e.currentTarget).attr("data-id");
      id && LocalStorage.addLastStore(id);
      if (LocalStorage.isMiniApp() && !LocalStorage.isOldApp()) {
        e.preventDefault();
        if (type === "popup") {
          MINI_APP.pop($(e.currentTarget).attr("href"));
        } else {
          MINI_APP.openSite({
            url: $(e.currentTarget).attr("href")
          });
        }
      }
    });
    if (LocalStorage.isMiniApp() && !LocalStorage.isOldApp()) {
      this.element.on("click", ".see-more-site a", (e) => {
        e.preventDefault();
        MINI_APP.openAvailableStore({ replace: window.location.pathname.indexOf(ROOT_GLOBAL.CHECKOUT) === 0 });
      });
    }

    if (this.isCallApi) {
      this.getApiStore();
      listenEvent(EVENTS.CHANGE_LANGUAGE, (data) => {
        this.getApiStore();
      })
    }
  }

  getApiStore(isShuffle = true) {
    let params = {
      ...Search.genDefaultParams(Search.SEARCH_TYPE.SITE, this.perPage ?? DEFAULT_PER_PAGE_STORES),
      ...SiteCategory.genParamsBstSale(SiteCategory.SALE_CATEGORY.value),
      f: {
        "state": "published"
      }
    }
    apiSearchSite(params,
      (data) => {
        if (data && data.data) {
          let storeData = data.data;
          typeof this.callBackApiData === "function" && this.callBackApiData(data.data);
          if (!this.noSlider && isShuffle) {
            storeData = shuffle(data.data);
          }
          this.setUpAvailableStore(storeData);
          if (this.section) {
            $(this.section).removeClass("hide");
          } else {
            $(this.parent).removeClass("hide");
          }
        }
      },
      (error) => {
        if (this.section) {
          $(this.section).addClass("hide");
        } else {
          $(this.parent).addClass("hide");
        }
      }
    )
  }

  setUpAvailableStore(data, paging, isLoadMore) {
    this.element.removeClass("is-loading");
    let siteData = this.isFullState ? Site.fromApiArray(data) : Site.fromApiArray(data).filter(item => item.siteMeta?.logoUrl && item.siteMeta?.url);
    if (this.rows !== 1) {
      siteData.splice(Math.floor(siteData.length / this.rows) * this.rows);
    }
    if (isLoadMore && !this.isPaging) {
      this.data = this.data.concat(siteData);
    } else {
      this.data = siteData;
      if (this.seeAll && siteData.length) {
        $(".see-more-site .see-all", this.element).attr("data-i18n", this.seeAll);
        $(".see-more-site a", this.element).attr("href", ROOT_GLOBAL.AVAILABLE_STORES);
        $(".see-more-site", this.element).removeClass("hide");
      }
    }

    let pagingData = Paging.fromApiObject(paging);
    this.paging = pagingData;
    this.isLoadMore = isLoadMore;

    if (!siteData.length) {
      setTimeout(() => {
        this.element.find(".logo-site").addClass("active");
      }, 500);
      return;
    }

    let htmlBranch = ``;
    for (let i = 0; i < siteData.length; i += this.rows) {
      let html = `<div class="row-box">`;
      for (let j = 0; j < this.rows; j++) {
        const site = siteData[i + j];
        html += site?.genHtml(this.isFullWidth);
      }
      html += `</div>`;
      htmlBranch += html;
    }
    if (!this.noSlider) {
      if (isLoadMore) {
        $(".flex-box", this.element).slick('slickAdd', htmlBranch);
      } else {
        $(".flex-box", this.element).slick('slickRemove', null, null, true)
        $(".flex-box", this.element).slick('slickAdd', htmlBranch);
      }
      $(".flex-box.slider-nav", this.element).slick("refresh");
    } else {
      if (isLoadMore) {
        $(".flex-box", this.element).append(htmlBranch);
      } else {
        $(".flex-box", this.element).html(htmlBranch);
      }
    }

    this.update();

    setTimeout(() => {
      this.element.find(".logo-site").addClass("active");
    }, 500);
  }

  setUpLoading() {
    if (!this.noSlider) {
      defer(() => window.innerWidth, () => {
        $(".box-data.loading", this.element).append(this.genLoadingItem(this.getSlideToShow() * this.rows));
        $(".box-data.loading .row-box", this.element).css("width", 100 / this.getSlideToShow() + "%");
      }, 1);
      return;
    }
    let paging = this.paging || Paging.fromApiObject({
      total_count: this.perPage * 2,
      current_page: 1
    });
    const left = paging.totalCount - paging.currentPage * this.perPage;
    $(".box-data.loading", this.element).append(this.genLoadingItem(this.perPage < left ? this.perPage : left));
  }

  genLoadingItem(num = 4) {
    let total = this.rows !== 1 ? Math.floor(num / this.rows) * this.rows : num;
    let result = "";
    for (let i = 0; i < total; i += this.rows) {
      let html = `<div class="row-box">`;
      for (let j = 0; j < this.rows; j++) {
        html += replaceVariable(require("html-loader!./item.html"), {
          class: ' loading',
          href: "",
          discountName: '',
          src: "",
          classImage: " animated-background-dark",
          classSiteInfo: " animated-background-dark",
          siteName: "",
          srcWhite: "",
          backgroundUrl: "",
          title: "",
        });
      }
      html += `</div>`;
      result += html;
    }
    return result;
  }

  hasData() {
    let result = false;
    this.data.forEach(element => {
      if (element.siteMeta?.url) {
        result = true;
        return true;
      }
    });
    return result;
  }

  startLoadMore() {
    if (!this.element) {
      return;
    }

    if (this.isPaging) {
      $(".flex-box", this.element).html("");
    }

    this.parent.parent().find(".load-more").attr("loading", true);
    this.element.addClass("is-loading");
  }

  stopLoadMore() {
    if (!this.element) {
      return;
    }
    $(this.parent).parent().find(".load-more").attr("loading", false);
    this.element.removeClass("is-loading");
  }

  getSlideToShow() {
    if (window.innerWidth >= 1100) {
      return this.slidesToShow;
    }
    if (window.innerWidth >= 900) {
      return 4;
    }
    if (window.innerWidth >= 768) {
      return 3;
    }
    return this.slidesToShowMobile;
  }

  getType() {
    return this.type;
  }

  checkType(t) {
    return this.type === t;
  }
}